import { SVGProps, Ref, forwardRef } from 'react';

export const Diagram60Size16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 2.533a5.466 5.466 0 1 1-3.865 9.333l-.849.848A6.667 6.667 0 1 0 8 1.334z"
                fill="currentColor"
            />
        </g>
    </svg>
));
Diagram60Size16Glyph.displayName = 'Diagram60Size16Glyph';
